import { useEffect, useState } from "react";

function isMobileOrTablet() {
  if (typeof navigator === "undefined") {
    return false;
  }

  const ua = navigator.userAgent.toLowerCase();
  const basicCheck =
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet|samsungbrowser/i.test(
      ua,
    );
  const isOldIPad = /ipad/.test(ua);
  const isNewIPad = /macintosh/.test(ua) && "ontouchstart" in document;
  return basicCheck || isOldIPad || isNewIPad;
}

function useIsWebScreen() {
  const [isWebScreen, setIsWebScreen] = useState(() => !isMobileOrTablet());
  const [isDesktop, setDesktop] = useState(false);
  const [isTabletSize, setTabletSize] = useState(false);
  useEffect(() => {
    const handleResize = (evt) => {
      const width = window.innerWidth;
      setDesktop(width >= 768);
      setTabletSize(width >= 768 && width <= 991);
      setIsWebScreen(!isMobileOrTablet());
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { isWebScreen, isDesktop, isTabletSize };
}

export default useIsWebScreen;
